import gql from 'graphql-tag'
import { generalSettingFragment, generalSettingExtendedFragment } from "@/graphql/settings/generalSettingFragments";

export const GENERALSETTINGS = gql`
    query generalSettings {
        generalSettings{
            ...generalSettingFragment
        }
    }
    ${generalSettingFragment}
`

export const GENERALSETTINGSEXTENDED = gql`
    query generalSettingsExtended {
        generalSettingsExtended{
            ...generalSettingExtendedFragment
        }
    }
    ${generalSettingExtendedFragment}
`